exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title[data-v-d1cf2edc] {\n  font-weight: bold;\n  font-size: large;\n}\n", ""]);
